import React, {
  createContext,
  useContext,
  useMemo
} from "react";

import { WindowLayer } from "./WindowLayer";

const WindowManagerContext = createContext(null);

export const WindowContext = createContext({
  zIndex: WindowLayer.CONTENT
});

export function WindowManager({
  children,
  portalTarget
}) {
  const resolvedPortalTarget =
    portalTarget !== undefined
      ? portalTarget
      : typeof document !== "undefined"
        ? document.body
        : null;

  const manager = useMemo(
    () => ({
      portalTarget: resolvedPortalTarget
    }),
    [resolvedPortalTarget]
  );

  const rootWindow = useMemo(
    () => ({
      zIndex: WindowLayer.CONTENT
    }),
    []
  );

  return (
    <WindowManagerContext.Provider value={manager}>
      <WindowContext.Provider value={rootWindow}>
        {children}
      </WindowContext.Provider>
    </WindowManagerContext.Provider>
  );
}

export function useWindowManager() {
  return useContext(WindowManagerContext);
}

export function useOwningWindow() {
  return useContext(WindowContext);
}
